import React, {useEffect, useState} from "react";
import {
  Backdrop,
  Box, Button, CircularProgress,
  Container,
  FormControl,
  InputLabel,
  makeStyles, MenuItem,
  Select,
  TextField,
  Typography,
} from "@material-ui/core";
import useAxios from 'axios-hooks';
import SideDrawer from "../../../Components/Advertisers/SideDrawer";
import CustomText from "../../../Components/Universal/CustomText";
import {getInquiries, createCustomerList} from "../../../Api";
import {Alert} from "@material-ui/lab";
import {getCustomerListPreset, removeCustomerListPreset} from "../../../Helpers";

export const useStyles = makeStyles(theme => ({
  formControl: {
    margin: theme.spacing(2),
    minWidth: 400,
    maxWidth: 500,
    width: 400,
  },
  stepForm: {
    width: 400,
    display: 'flex',
    flexDirection: 'column',
  },
}));

const CreateCustomerList = ({history}) => {
  const [formData, setFormData] = useState({
    description: '',
    name: '',
    inquiry_id: '',
    inquiry_option_name: '',
  });
  const [errorMsg, setErrorMsg] = useState('');
  const [{data: inquiryData, loading: inquiryLoading}] = useAxios(getInquiries(), { manual: false });
  const [{data: customerListData, loading: customerListCreating, error: cmlError}, createCustomerListAction] = useAxios(createCustomerList(), { manual: true });
  const [inquiries, setInquiries] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    if (inquiryData && inquiryData.inquiries) {
      setInquiries(inquiryData.inquiries);
    }
  }, [inquiryData]);

  useEffect(() => {
    if (customerListData) {
      if (customerListData.error) {
        setErrorMsg(customerListData.message);
      } else { // Success here
        history.replace('/advertiser/customerlists');
      }
    } else if (cmlError) {
      setErrorMsg('Unable to save customer list, please try again later.');
    }
  }, [customerListData, cmlError]);

  useEffect(() => {
    const initialData = getCustomerListPreset();
    setFormData({...formData, ...initialData});
    removeCustomerListPreset();
  }, []);

  const fieldChange = ({target: { value, name }}) => setFormData({...formData, [name]: value});

  const handleSubmit = () => {
    if (formData.name.length < 2 || formData.name.length > 100 ) {
      setErrorMsg('Customer list name should be longer than 2 characters and less than 100');
      return;
    }

    if (formData.description > 500) {
      setErrorMsg('Customer list description should not be longer than 500 characters');
      return;
    }

    setErrorMsg('');

    createCustomerListAction({
      data: {...formData},
    });
  };

  return (
    <SideDrawer>
      <Container>
        <Backdrop className={classes.backdrop} open={inquiryLoading || customerListCreating}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <p>&nbsp;</p>
        <p>&nbsp;</p>
        <CustomText
          text={`Create Customer List`}
          style='titleLarge'
          margin='40px 0 0 0'
       />
        <Box display='flex' justifyContent='center' mt={2}>
          <form className={classes.stepForm}>
            <FormControl className={classes.formControl}>
              <TextField
                id='customer-list-description'
                label='Name for customer list'
                name='name'
                fullWidth
                value={formData.name}
                onChange={fieldChange}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                id='customer-list-description'
                label='Description for customer list'
                name='description'
                multiline
                rows={3}
                rowsMax={8}
                fullWidth
                value={formData.description}
                onChange={fieldChange}
              />
              <Typography className={classes.radioGroupLabel}>
                {formData.description.length} Characters (200 max.)
              </Typography>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel id='inquiry-select-label-field'>Select Campaign</InputLabel>
              <Select
                labelId="inquiry-select-label-field"
                id="inquiry-select-field"
                name='inquiry_id'
                value={formData.inquiry_id}
                onChange={fieldChange}
              >
                {inquiries.map(inq => (
                  <MenuItem key={inq.inquiry_id} value={inq.inquiry_id}>
                    {inq.inquiry_question}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <InputLabel id='inquiry-option-select-label-field'>Select Response Option</InputLabel>
              <Select
                labelId="inquiry-option-select-label-field"
                id="inquiry-option-select-field"
                name='inquiry_option_name'
                value={formData.inquiry_option_name}
                onChange={fieldChange}
              >
                {inquiries[formData.inquiry_id] && inquiries[formData.inquiry_id].inquiry_options.map(option => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {errorMsg && errorMsg.length > 0 && (
              <Box display="flex" justifyContent="center" mt={5}>
                <Alert severity="error">{errorMsg}</Alert>
              </Box>
            )}
            <Box display="flex" justifyContent="center" mt={8}>
              <Button
                disabled={customerListCreating}
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                Create
              </Button>
            </Box>
          </form>
        </Box>
      </Container>
    </SideDrawer>
  );
};

export default CreateCustomerList;
